(() => {
  // 默认吊牌图标（接近 Moonkie）
  const TAG_SVG =
    '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M3.8 12.4l7.8-7.8a1.6 1.6 0 0 1 2.3 0l5.5 5.5a1.6 1.6 0 0 1 0 2.3l-7.8 7.8a1.6 1.6 0 0 1-2.3 0L3.8 14.7a1.6 1.6 0 0 1 0-2.3z" fill="currentColor"/><circle cx="16.2" cy="7.8" r="1.35" fill="#fff"/></svg>';

  const VIDEO_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><rect x="3" y="6" width="13" height="12" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M16 10.5l5-2.5v10l-5-2.5V10.5z" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>';

  const pauseModalVideos = (modal) => {
    modal?.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (err) {
        /* ignore */
      }
    });
  };

  const closeOpenModals = () => {
    document.querySelectorAll('.ig-post-modal[open]').forEach((modal) => {
      pauseModalVideos(modal);
      modal.close();
    });
    document.documentElement.classList.remove('ig-modal-open');
  };

  if (!document.documentElement.dataset.igEscapeBound) {
    document.documentElement.dataset.igEscapeBound = 'true';
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!document.querySelector('.ig-post-modal[open]')) return;
      closeOpenModals();
    });
  }

  const linkifyHashtags = (captionEl, baseUrl) => {
    if (!captionEl || captionEl.dataset.igHashtagsLinked === 'true') return;
    captionEl.dataset.igHashtagsLinked = 'true';

    const prefix = (baseUrl || 'https://www.instagram.com/explore/tags/').replace(/\/?$/, '/');
    const walker = document.createTreeWalker(captionEl, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    const pattern = /#([A-Za-z0-9_]+)/g;

    textNodes.forEach((textNode) => {
      if (!textNode.parentElement || textNode.parentElement.closest('a')) return;
      const text = textNode.nodeValue;
      if (!text || !text.includes('#')) return;

      pattern.lastIndex = 0;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;

      const frag = document.createDocumentFragment();
      let lastIndex = 0;
      let match;
      while ((match = pattern.exec(text)) !== null) {
        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }
        const link = document.createElement('a');
        link.className = 'ig-post-modal__hashtag';
        link.href = `${prefix}${encodeURIComponent(match[1].toLowerCase())}/`;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = match[0];
        frag.appendChild(link);
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex === 0) return;
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });

    captionEl.querySelectorAll('a').forEach((anchor) => {
      if (!anchor.classList.contains('ig-post-modal__hashtag')) {
        anchor.classList.add('ig-post-modal__hashtag');
      }
      if (!anchor.getAttribute('target')) {
        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
      }
    });
  };

  const initModal = (root, modal) => {
    if (!modal || modal.dataset.igModalBound === 'true') return;
    modal.dataset.igModalBound = 'true';

    const hashtagBase = root?.dataset.hashtagBase || 'https://www.instagram.com/explore/tags/';
    modal.querySelectorAll('[data-ig-caption]').forEach((caption) => {
      linkifyHashtags(caption, hashtagBase);
    });

    const slides = Array.from(modal.querySelectorAll('[data-ig-modal-slide]'));
    const prev = modal.querySelector('[data-ig-modal-prev]');
    const next = modal.querySelector('[data-ig-modal-next]');
    let slideIndex = 0;

    const showSlide = (index) => {
      if (slides.length === 0) return;
      slideIndex = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === slideIndex;
        slide.hidden = !active;
        const video = slide.querySelector('video');
        if (!video) return;
        if (active) {
          try {
            video.currentTime = 0;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } catch (err) {
            /* ignore autoplay block */
          }
        } else {
          try {
            video.pause();
          } catch (err) {
            /* ignore */
          }
        }
      });
      const multi = slides.length > 1;
      if (prev) prev.hidden = !multi;
      if (next) next.hidden = !multi;
    };

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      showSlide(slideIndex - 1);
    });
    next?.addEventListener('click', (e) => {
      e.preventDefault();
      showSlide(slideIndex + 1);
    });

    showSlide(0);

    const viewProductsBtn = modal.querySelector('[data-ig-view-products]');
    const pinsLayer = modal.querySelector('[data-ig-pins]');
    const pins = Array.from(modal.querySelectorAll('[data-ig-pin]'));
    const productCards = Array.from(modal.querySelectorAll('[data-ig-product-card]'));
    const viewLabelEl = viewProductsBtn?.querySelector('[data-ig-view-label]');
    const labelView = viewProductsBtn?.dataset.labelView || 'View products';
    const labelHide = viewProductsBtn?.dataset.labelHide || 'Hide products';
    let pinsLocked = false;

    const clearPinHighlight = () => {
      pins.forEach((pin) => {
        pin.classList.remove('is-active', 'is-dimmed', 'is-solo');
      });
      productCards.forEach((card) => card.classList.remove('is-active'));
    };

    const highlightProduct = (productId) => {
      if (!productId || !pinsLayer) return;

      pinsLayer.hidden = false;
      clearPinHighlight();

      pins.forEach((pin) => {
        const match = pin.dataset.igProductId === productId;
        if (pinsLocked) {
          pin.classList.toggle('is-active', match);
          pin.classList.toggle('is-dimmed', !match);
        } else {
          pin.classList.toggle('is-solo', match);
          pin.classList.toggle('is-dimmed', !match);
        }
      });

      productCards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.igProductId === productId);
      });
    };

    const setPinsVisible = (visible) => {
      if (!pinsLayer || !viewProductsBtn) return;
      pinsLocked = visible;
      pinsLayer.hidden = !visible;
      clearPinHighlight();
      viewProductsBtn.setAttribute('aria-pressed', visible ? 'true' : 'false');
      if (viewLabelEl) viewLabelEl.textContent = visible ? labelHide : labelView;
    };

    viewProductsBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      setPinsVisible(!pinsLocked);
    });

    productCards.forEach((card) => {
      const productId = card.dataset.igProductId;
      if (!productId) return;

      card.addEventListener('mouseenter', () => {
        highlightProduct(productId);
      });
      card.addEventListener('mouseleave', () => {
        clearPinHighlight();
        if (!pinsLocked && pinsLayer) pinsLayer.hidden = true;
      });
      card.addEventListener('focusin', () => {
        highlightProduct(productId);
      });
      card.addEventListener('focusout', (event) => {
        if (card.contains(event.relatedTarget)) return;
        clearPinHighlight();
        if (!pinsLocked && pinsLayer) pinsLayer.hidden = true;
      });
    });

    pins.forEach((pin) => {
      pin.addEventListener('mouseenter', () => {
        const productId = pin.dataset.igProductId;
        if (!productId) return;
        productCards.forEach((card) => {
          card.classList.toggle('is-active', card.dataset.igProductId === productId);
        });
        pins.forEach((p) => {
          const match = p.dataset.igProductId === productId;
          p.classList.toggle('is-active', match);
          p.classList.toggle('is-dimmed', !match);
          p.classList.remove('is-solo');
        });
      });
      pin.addEventListener('mouseleave', () => {
        clearPinHighlight();
      });
    });

    modal.addEventListener('close', () => {
      pauseModalVideos(modal);
      showSlide(0);
      setPinsVisible(false);
    });

    setPinsVisible(false);

    let touchStartX = 0;
    const carousel = modal.querySelector('.ig-post-modal__carousel');
    carousel?.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    carousel?.addEventListener(
      'touchend',
      (e) => {
        if (slides.length <= 1) return;
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        showSlide(slideIndex + (delta < 0 ? 1 : -1));
      },
      { passive: true }
    );
  };

  const initGallery = (root) => {
    if (!root || root.dataset.igBound === 'true') return;
    root.dataset.igBound = 'true';

    const stage = root.querySelector('[data-ig-stage]');
    const prevBtn = root.querySelector('[data-ig-prev]');
    const nextBtn = root.querySelector('[data-ig-next]');
    const dotsHost = root.querySelector('[data-ig-dots]');
    const slots = Array.from(root.querySelectorAll('[data-ig-slot]'));
    const modals = Array.from(root.querySelectorAll('[data-ig-modal]'));
    modals.forEach((modal) => initModal(root, modal));

    if (!stage || !prevBtn || !nextBtn || slots.length === 0) return;

    const poolNodes = Array.from(root.querySelectorAll('[data-ig-pool] [data-ig-item]'));
    const pickImageUrl = (img) => {
      if (!img) return '';
      const direct = img.getAttribute('src') || img.currentSrc || '';
      if (direct) return direct;
      const srcset = img.getAttribute('srcset') || '';
      if (!srcset) return '';
      let best = '';
      let bestW = 0;
      srcset.split(',').forEach((part) => {
        const bits = part.trim().split(/\s+/);
        const url = bits[0] || '';
        const w = parseInt(String(bits[1] || '').replace('w', ''), 10) || 0;
        if (url && w >= bestW) {
          bestW = w;
          best = url;
        }
      });
      return best;
    };

    const items = poolNodes
      .map((node) => {
        const img = node.querySelector('img');
        return {
          index: node.dataset.igIndex || '0',
          src: pickImageUrl(img),
          srcset: img ? img.getAttribute('srcset') || '' : '',
          sizes: img ? img.getAttribute('sizes') || '' : '',
          alt: img ? img.getAttribute('alt') || '' : '',
          hasProducts: node.dataset.hasProducts === 'true',
          isVideo: node.dataset.isVideo === 'true',
          videoSrc: node.dataset.videoSrc || '',
        };
      })
      .filter((item) => item.src || item.videoSrc);

    let page = 0;
    let animating = false;

    const getPageSize = () => {
      // 全端统一：左大图 + 右 8 小图（与 PC 同构，移动端等比例缩小）
      return Math.min(Number(root.dataset.pageSize || 9), slots.length);
    };

    const getPageCount = () => {
      const size = getPageSize();
      return Math.max(1, Math.ceil(items.length / size));
    };

    const playModalVideo = (videoEl) => {
      if (!videoEl) return;
      try {
        videoEl.removeAttribute('poster');
        videoEl.playsInline = true;
        videoEl.setAttribute('playsinline', '');
        // 弹窗内允许有声，但先静音以通过自动播放策略，用户可点控件开声
        if (videoEl.paused) {
          const playPromise = videoEl.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }
      } catch (err) {
        /* ignore */
      }
    };

    const openModal = (itemIndex) => {
      const modal = root.querySelector(`[data-ig-modal][data-ig-index="${itemIndex}"]`);
      if (!modal || typeof modal.showModal !== 'function') return;
      modal.showModal();
      document.documentElement.classList.add('ig-modal-open');
      modal.querySelectorAll('video').forEach((video) => {
        video.removeAttribute('poster');
      });
      const firstVideo = modal.querySelector('[data-ig-modal-slide]:not([hidden]) video');
      playModalVideo(firstVideo);
    };

    if (!stage.dataset.igClickBound) {
      stage.dataset.igClickBound = 'true';
      stage.addEventListener('click', (event) => {
        const media = event.target.closest('[data-ig-media]');
        if (!media || !stage.contains(media)) return;
        const idx = media.dataset.igOpenIndex;
        if (idx != null && idx !== '') openModal(idx);
      });
    }

    const closeModal = (modal) => {
      if (!modal) return;
      pauseModalVideos(modal);
      modal.close();
      if (!document.querySelector('.ig-post-modal[open]')) {
        document.documentElement.classList.remove('ig-modal-open');
      }
    };

    root.querySelectorAll('[data-ig-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        closeModal(btn.closest('[data-ig-modal]'));
      });
    });

    modals.forEach((modal) => {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal(modal);
      });
      modal.addEventListener('close', () => {
        pauseModalVideos(modal);
        if (!document.querySelector('.ig-post-modal[open]')) {
          document.documentElement.classList.remove('ig-modal-open');
        }
      });
    });

    const ensureTag = (host, show) => {
      let tag = host.querySelector('[data-ig-tag]');
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'instagram-gallery__tag';
        tag.setAttribute('data-ig-tag', '');
        tag.setAttribute('aria-hidden', 'true');
        const customIcon = root.dataset.tagIcon || '';
        if (customIcon) {
          const img = document.createElement('img');
          img.src = customIcon;
          img.alt = '';
          img.width = 15;
          img.height = 15;
          img.decoding = 'async';
          tag.appendChild(img);
        } else {
          tag.innerHTML = TAG_SVG;
        }
        host.appendChild(tag);
      }
      tag.hidden = !show;
    };

    const ensureVideoBadge = (host, show) => {
      let badge = host.querySelector('[data-ig-video-badge]');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'instagram-gallery__video-badge';
        badge.setAttribute('data-ig-video-badge', '');
        badge.setAttribute('aria-hidden', 'true');
        badge.innerHTML = VIDEO_SVG;
        host.appendChild(badge);
      }
      badge.hidden = !show;
    };

    const bindOpen = (host, itemIndex) => {
      host.dataset.igOpenIndex = String(itemIndex);
    };

    const setMediaHost = (slot) => {
      const mediaHost = slot.querySelector('[data-ig-media]');
      if (!mediaHost) return null;
      if (mediaHost.tagName.toLowerCase() === 'button') return mediaHost;

      const nextHost = document.createElement('button');
      nextHost.type = 'button';
      nextHost.className = 'instagram-gallery__media instagram-gallery__media--btn';
      nextHost.setAttribute('data-ig-media', '');
      while (mediaHost.firstChild) {
        nextHost.appendChild(mediaHost.firstChild);
      }
      mediaHost.replaceWith(nextHost);
      return nextHost;
    };

    const renderDots = () => {
      if (!dotsHost) return;
      const pageCount = getPageCount();
      if (items.length <= getPageSize()) {
        dotsHost.hidden = true;
        dotsHost.innerHTML = '';
        return;
      }
      dotsHost.hidden = false;
      dotsHost.innerHTML = '';
      for (let i = 0; i < pageCount; i += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'instagram-gallery__dot' + (i === page ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', `Page ${i + 1}`);
        btn.setAttribute('aria-selected', i === page ? 'true' : 'false');
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          goToPage(i);
        });
        dotsHost.appendChild(btn);
      }
    };

    const playGridVideo = (videoEl) => {
      if (!videoEl) return;
      try {
        videoEl.muted = true;
        videoEl.defaultMuted = true;
        videoEl.playsInline = true;
        videoEl.setAttribute('playsinline', '');
        videoEl.setAttribute('webkit-playsinline', '');
        videoEl.loop = true;
        videoEl.removeAttribute('poster');
        const playPromise = videoEl.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } catch (err) {
        /* ignore */
      }
    };

    const applyCoverStyles = (el) => {
      if (!el) return;
      el.style.setProperty('position', 'absolute', 'important');
      el.style.setProperty('inset', '0', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('height', '100%', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('object-fit', 'cover', 'important');
      el.style.setProperty('object-position', 'center center', 'important');
    };

    const hideGridVideo = (videoEl) => {
      if (!videoEl) return;
      try {
        videoEl.pause();
        videoEl.removeAttribute('src');
        videoEl.load();
      } catch (err) {
        /* ignore */
      }
      videoEl.setAttribute('hidden', '');
      videoEl.style.setProperty('display', 'none', 'important');
      videoEl.style.setProperty('visibility', 'hidden', 'important');
      videoEl.style.setProperty('pointer-events', 'none', 'important');
      videoEl.style.setProperty('z-index', '-1', 'important');
    };

    const showGridImage = (imgEl) => {
      if (!imgEl) return;
      imgEl.removeAttribute('hidden');
      imgEl.style.removeProperty('display');
      imgEl.style.removeProperty('visibility');
      imgEl.style.setProperty('z-index', '1', 'important');
      applyCoverStyles(imgEl);
    };

    const hideGridImage = (imgEl) => {
      if (!imgEl) return;
      imgEl.setAttribute('hidden', '');
      imgEl.style.setProperty('display', 'none', 'important');
    };

    const showGridVideo = (videoEl, imgEl, item) => {
      if (!videoEl) return;

      // 视频加载前先垫主图，避免黑屏；开始播放后隐藏图片
      if (imgEl && item.src) {
        showGridImage(imgEl);
        imgEl.src = item.src;
        if (item.srcset) imgEl.setAttribute('srcset', item.srcset);
        else imgEl.removeAttribute('srcset');
        if (item.sizes) imgEl.setAttribute('sizes', item.sizes);
        else imgEl.removeAttribute('sizes');
        imgEl.alt = item.alt || '';
      } else {
        hideGridImage(imgEl);
      }

      if (videoEl.getAttribute('src') !== item.videoSrc) {
        videoEl.src = item.videoSrc;
      }

      videoEl.removeAttribute('hidden');
      videoEl.style.removeProperty('display');
      videoEl.style.removeProperty('visibility');
      videoEl.style.setProperty('pointer-events', 'none', 'important');
      videoEl.style.setProperty('z-index', '2', 'important');
      applyCoverStyles(videoEl);

      if (!videoEl.dataset.igGridVideoBound) {
        videoEl.dataset.igGridVideoBound = 'true';
        const onPlaying = () => {
          hideGridImage(imgEl);
        };
        const onError = () => {
          hideGridVideo(videoEl);
          showGridImage(imgEl);
        };
        videoEl.addEventListener('playing', onPlaying);
        videoEl.addEventListener('error', onError);
      }

      playGridVideo(videoEl);
    };

    const applyCompactLayout = (visibleCount) => {
      const thumbCount = Math.max(0, visibleCount - 1);
      const thumbCols = thumbCount === 0 ? 0 : Math.ceil(thumbCount / 2);
      const hasPosts = items.length > 0;

      stage.dataset.igVisible = String(hasPosts ? visibleCount : 0);
      stage.dataset.igCompact = hasPosts ? 'true' : 'false';
      if (hasPosts && thumbCols > 0) {
        stage.style.setProperty('--ig-thumb-cols', String(thumbCols));
      } else {
        stage.style.removeProperty('--ig-thumb-cols');
      }

      slots.forEach((slot, slotIndex) => {
        const show = hasPosts ? slotIndex < visibleCount : slotIndex < getPageSize();
        slot.hidden = !show;
        slot.classList.toggle('is-empty', !show);
        // 右侧小图为奇数时，最后一张纵向撑满，避免空洞
        const isTailFill = show && slotIndex > 0 && slotIndex === visibleCount - 1 && thumbCount % 2 === 1;
        slot.classList.toggle('is-fill-tail', isTailFill);
      });
    };

    const fillSlots = () => {
      const pageSize = getPageSize();
      const pageCount = getPageCount();
      page = ((page % pageCount) + pageCount) % pageCount;
      const start = page * pageSize;
      const visibleCount =
        items.length === 0 ? pageSize : Math.min(pageSize, Math.max(0, items.length - start));

      applyCompactLayout(visibleCount);

      slots.forEach((slot, slotIndex) => {
        const itemIndex = start + slotIndex;
        const item = itemIndex < items.length ? items[itemIndex] : null;
        const host = setMediaHost(slot);
        const img = host ? host.querySelector('[data-ig-image]') : slot.querySelector('[data-ig-image]');
        const video = host ? host.querySelector('[data-ig-video]') : slot.querySelector('[data-ig-video]');
        const placeholder = host ? host.querySelector('[data-ig-placeholder]') : slot.querySelector('[data-ig-placeholder]');
        if (!img) return;

        // 有真实帖子时：不展示空位占位图，格子已在 applyCompactLayout 里隐藏
        if (!item) {
          hideGridImage(img);
          img.removeAttribute('src');
          img.removeAttribute('srcset');
          hideGridVideo(video);
          if (placeholder) placeholder.hidden = items.length > 0;
          if (host) {
            host.removeAttribute('data-ig-open-index');
            ensureVideoBadge(host, false);
            ensureTag(host, false);
          }
          return;
        }

        if (placeholder) placeholder.hidden = true;

        const useVideo = Boolean(item.isVideo && item.videoSrc);

        if (useVideo && video) {
          showGridVideo(video, img, item);
        } else {
          hideGridVideo(video);
          showGridImage(img);
          if (item.src) {
            img.src = item.src;
            if (item.srcset) img.setAttribute('srcset', item.srcset);
            else img.removeAttribute('srcset');
            if (item.sizes) img.setAttribute('sizes', item.sizes);
            else img.removeAttribute('sizes');
          }
          img.alt = item.alt || '';
        }

        if (!host) return;
        host.setAttribute('aria-label', item.alt || (useVideo ? 'View video post' : 'View post'));
        ensureVideoBadge(host, false);
        ensureTag(host, item.hasProducts);
        bindOpen(host, item.index);
      });

      const canMove = getPageCount() > 1;
      prevBtn.disabled = !canMove;
      nextBtn.disabled = !canMove;
      prevBtn.classList.toggle('is-disabled', !canMove);
      nextBtn.classList.toggle('is-disabled', !canMove);
      renderDots();
    };

    const goToPage = (nextPage) => {
      const pageCount = getPageCount();
      if (pageCount <= 1 || animating) return;
      animating = true;
      stage.classList.add('is-animating');
      page = ((nextPage % pageCount) + pageCount) % pageCount;
      fillSlots();
      window.setTimeout(() => {
        stage.classList.remove('is-animating');
        animating = false;
      }, 320);
    };

    const go = (dir) => {
      goToPage(page + dir);
    };

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      go(-1);
    });
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      go(1);
    });

    let touchStartX = 0;
    stage.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    stage.addEventListener(
      'touchend',
      (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        go(delta < 0 ? 1 : -1);
      },
      { passive: true }
    );

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        fillSlots();
      }, 150);
    });

    fillSlots();
  };

  const boot = () => {
    document.querySelectorAll('[data-instagram-gallery]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-instagram-gallery]');
    if (root) {
      root.dataset.igBound = '';
      root.querySelectorAll('[data-ig-modal]').forEach((m) => {
        m.dataset.igModalBound = '';
      });
      initGallery(root);
    }
  });
})();
